/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { countryCodes } from '@/constants/locale';
import { DynamicLinks } from '@/features/dlm/components/DynamicLinks';
import { VehicleDynamicLinks } from '@/features/dlm/components/VehicleDynamicLinks';
import { FeatureFlag } from '@/features/globalConfig';
import { useLocale } from '@/hooks/useLocale';
import { usePageType } from '../../../api/getPageType';

export const CMSPopularSearches = () => {
  const { data: pageTypeData } = usePageType();
  const locale = useLocale();

  const { catalogRepositoryId, makeModelYearPath } = pageTypeData ?? {};

  if (!catalogRepositoryId || locale !== countryCodes.us) {
    return null;
  }

  return (
    <>
      {makeModelYearPath ? (
        <FeatureFlag flag="DLM_YMM_CATEGORY_ENABLED">
          <VehicleDynamicLinks seoRepositoryId={catalogRepositoryId} />
        </FeatureFlag>
      ) : (
        <FeatureFlag flag="DLM_CATEGORY_ENABLED">
          <DynamicLinks seoRepositoryId={catalogRepositoryId} />
        </FeatureFlag>
      )}
    </>
  );
};
